"use client";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { SlArrowLeft } from "react-icons/sl";
import classes from "../../Components/Auth/RightSection.module.css";

export default function MyAccountForm() {
  const navigate = useNavigate();

  const [registrationData, setRegistrationData] = useState({});
  const [mobile, setMobile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errmessage, seterrmessage] = useState({ isError: false, message: "" });

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setRegistrationData(
      JSON.parse(localStorage.getItem("mmt_registration_data"))
    );
    setMobile(localStorage.getItem("mmt_login_mobile"));
  }, []);

  useEffect(() => {
    if (registrationData) {
      setValue("gst_number", registrationData?.gst_number);
      setValue("location", registrationData?.gst_details?.adadr[0]?.addr?.loc);
      setValue("company_name", registrationData?.gst_details?.tradeNam);
    }
  }, [registrationData, setValue]);

  const onSubmit = async (data) => {
    console.log("data", data);

    setIsLoading(true);
    
    data.mobile_number = registrationData?.mobile;
    axios
      .post(`${process.env.REACT_APP_OTP_URL}otp/register-user`, data)
      .then((res) => {
        setIsLoading(false);
        localStorage.removeItem("mmt_registration_data");
        localStorage.removeItem("mmt_login_mobile");
        navigate("/login");
      })
      .catch((errors) => {
        if (errors?.response?.status === 400) {
          seterrmessage({
            isError: true,
            message: errors?.response?.data?.message,
          });
        } else {
          seterrmessage({
            isError: true,
            message: "Something went wrong. Please try after some time!",
          });
        }
        setIsLoading(false);
      });
  };

  return (
    <div className="w-full min-h-screen flex flex-col items-center p-4 md:p-8 bg-gray-100">
      {/* <div className="w-full max-w-4xl"> */}
      <span
          onClick={() => navigate("/registration")}
          // className="inline-flex items-center gap-2 text-gray-400 cursor-pointer mb-4"
          className="absolute top-4 left-4 md:top-6 md:left-8 text-gray-500 flex gap-2 items-center cursor-pointer"

        >
          <SlArrowLeft className="text-xs" /> Back
        </span>
      {/* </div> */}
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-md p-6 md:p-10">
      
        <h2 className="text-xl font-semibold text-center mb-3">
          Let’s start the journey with Make My Tool
        </h2>
        <p className="text-center text-gray-500 mb-6">
          Please fill out the form below
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Company Name
              </label>
              <input
                type="text"
                disabled={registrationData?.gst_details?.tradeNam ? true : false}
                {...register("company_name", {
                  required: "Company name is required!",
                })}
                className={`block w-full px-3 py-2 border rounded-md ${
                  errors.company_name ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Please enter company name"
              />
              {errors.company_name && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.company_name.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                GST Number
              </label>
              <input
                type="text"
                disabled={registrationData?.gst_number ? true : false}
                {...register("gst_number", {
                  required: "GST Number is required!",
                })}
                className={`block w-full px-3 py-2 border rounded-md ${
                  errors.gst_number ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Please enter GST number"
              />
              {errors.gst_number && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.gst_number.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Client Type
              </label>
              <select
                {...register("customer_type", {
                  required: "Client Type is required!",
                })}
                className={`block w-full px-3 py-2 border rounded-md ${
                  errors.customer_type ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="" disabled selected>
                  Please select client type
                </option>
                <option value="Manufacturer">Manufacturer</option>
                <option value="Distributor">Distributor</option>
                <option value="Supplier">Supplier</option>
              </select>
              {errors.customer_type && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.customer_type.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Location
              </label>
              <input
                type="text"
                value={registrationData?.gst_details?.adadr[0]?.addr?.loc}
                disabled={
                  registrationData?.gst_details?.adadr[0]?.addr?.loc
                    ? true
                    : false
                }
                {...register("location", {
                  required: "Location is required!",
                })}
                className={`block w-full px-3 py-2 border rounded-md ${
                  errors.location ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Please enter location"
              />
              {errors.location && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.location.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                User Name
              </label>
              <input
                type="text"
                {...register("username", {
                  required: "User Name is required!",
                })}
                className={`block w-full px-3 py-2 border rounded-md ${
                  errors.username ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Please enter username"
              />
              {errors.username && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.username.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                {...register("email", {
                  required: "Email is required!",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Invalid email address",
                  },
                })}
                className={`block w-full px-3 py-2 border rounded-md ${
                  errors.email ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Please enter email"
              />
              {errors.email && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Contact Number
              </label>
              <input
                type="text"
                value={mobile}
                disabled
                className="block w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          {errmessage.isError && (
            <div className="mt-4 text-center text-red-500 text-sm">
              {errmessage.message}
            </div>
          )}

          <div className="mt-6 flex justify-center">
            <button
              type="submit"
              className={`w-full md:w-1/2 py-3 px-6 text-white rounded-md ${
                isLoading ? "secondary-color" : "main-color"
              } flex items-center justify-center`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
